import { createRouter, createWebHistory } from "vue-router";
import Home from "@/views/home/HomePage.vue";
import DepartmentPage from "@/views/department/DepartmentPage.vue"
import AdminLayout from "@/components/AdminLayout.vue";
import StaffPage from "@/views/staff/StaffPage.vue";

const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/components/LoginPage.vue"),
  },
  {
    path: "/admin",
    component: AdminLayout,
    meta: { requiresAuth: true },
    children: [
      { path: "/admin/dashboard", name: "Dashboard", component: Home },
      { path: "/admin/department", name: "Department", component: DepartmentPage },
      { path: "/admin/staff", name: "Staff", component: StaffPage }
    ]
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (to.meta.requiresAuth && !token) {
    next('/login');
  } else {
    next();
  }
});

export default router;
